import { useEffect } from 'react';

const initializeLocalStorageWithObject = (data: Record<string, string>) => {
  Object.entries(data).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
};

const SsoLogin = () => {
  useEffect(() => {
    const queryParam = new URLSearchParams(window.location.search);
    if (queryParam.get('data')) {
      initializeLocalStorageWithObject(JSON.parse(queryParam.get('data')));
      window.location.href = window.location.origin;
    }
  }, []);
};

export { SsoLogin };
